import { useState } from 'react';
import { Container } from '@mui/material';
import Search from './components/Search';
import Results from './components/Results';
import { ProductTypeId, TerminalType } from './types/types';
import { HEAT_PUMP_PRODUCT_TYPES } from './constants/productTypes';

export default function App() {
  const [selectedType, setSelectedType] = useState<ProductTypeId | null>(null);
  const [selectedComune, setSelectedComune] = useState<string | null>(null)
  const [selectedTerminal, setSelectedTerminal] = useState<TerminalType | null>(null)
  const [selectedProduct, setSelectedProduct] = useState<string | null>(null)
  const [selectedService, setSelectedService] = useState<string | null>(null)
  const [selectedPanels, setSelectedPanels] = useState<string | null>(null)
  const [showResults, setShowResults] = useState(false);

  function setType(data: ProductTypeId | null) {
    setSelectedType(data);
  }

  function setComune(data: string | null) {
    setSelectedComune(data);
  }

  function setProduct(data: string | null) {
    setSelectedProduct(data);
  }

  function setTerminal(data: TerminalType | null) {
    setSelectedTerminal(data);
  }

  function setShow() {
    setShowResults(value => !value)
  }

  function setService(data: string | null) {
    setSelectedService(data);
  }

  function setPanels(data: string | null) {
    setSelectedPanels(data);
  }

  const isHeatPumpType = selectedType ? HEAT_PUMP_PRODUCT_TYPES.includes(selectedType) : false;
  const isSolarType = selectedType === ProductTypeId.SOLARE;
  const isWaterHeaterType = selectedType === ProductTypeId.SCALDACQUA;
  const canCalculate = Boolean(
    selectedType &&
    selectedProduct &&
    (
      (isHeatPumpType && selectedComune && selectedTerminal) ||
      (isSolarType && selectedService && selectedPanels) ||
      isWaterHeaterType
    )
  );

  return (
    <Container
      sx={{ padding: "0 !important" }}
    >
      <div className="flex flex-col mx-auto gap-8 md:gap-10 my-8 font-lato text-blue max-w-[1300px]">
        <div className='flex flex-col gap-2 md:gap-5 mx-5'>
          <h3 className='font-bold'>Che cos'è il Conto Termico 3.0</h3>
          <p className='text-[18px]'>
          Il CONTO TERMICO 3.0 è il nuovo incentivo erogato dal GSE (Gestore Servizi Energetici), alternativo e NON CUMULABILE con la detrazione fiscale in 10 anni del 65%- 50%. Questo incentivo è particolarmente vantaggioso in quanto l'importo spettante verrà accreditato direttamente sul conto corrente entro 30 giorni dal bimestre in cui è stata sottoscritta la scheda- contratto.
          </p>
        </div>
        <div className='md:hidden w-full h-[1px] bg-gray/80'></div>
        {showResults ?
          <Results
            tipo={selectedType!}
            setComune={setComune}
            setTerminal={setTerminal}
            setProduct={setProduct}
            setType={setType}
            setShow={setShow}
            comune={selectedComune}
            terminale={selectedTerminal}
            modello={selectedProduct!}
            panels={selectedPanels}
            service={selectedService}
          />
          :
          <Search
            selectedType={selectedType}
            selectedProduct={selectedProduct}
            selectedComune={selectedComune}
            selectedTerminal={selectedTerminal}
            selectedPanels={selectedPanels}
            selectedService={selectedService}
            setType={setType}
            setComune={setComune}
            setTerminal={setTerminal}
            setProduct={setProduct}
            setResults={setShow}
            setService={setService}
            setPanels={setPanels}
            disabled={!canCalculate}
          />
        }
        <div className='md:hidden w-full h-[1px] bg-gray/80'></div>
      </div>
    </Container>
  );
}
